/* import __COLOCATED_TEMPLATE__ from './finish-timing-bib-entry-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class FinishTimingComponent extends Component 
{
	@service store;
	@service ajax;
	
	@tracked enteredBib = null;
	
	async saveBib(isPosted)
	{
		var event = this.args.event;
		
		var value = this.enteredBib;
		
		if(value == null || (Number.isNaN(parseInt(value)) && value != '-'))
		{
			alert('invalid bib number');
			this.enteredBib = null;
			return;
		}
		if(isPosted)
		{
			const response = await this.ajax.request("/events/"+event.id+"/postBibFinish/"+value);
			
			if(response.error != null)
				alert(response.error);
		}
		else
		{
			const response = await this.ajax.request("/events/"+event.id+"/enterBibFinish/"+value);
			
			if(response.error != null)
				alert(response.error);
		}
		
		this.enteredBib = null;
	}

	@action
	enterBib(browserEvent)
	{
		if(!browserEvent.shiftKey)
		{
			this.saveBib(false);
		}
	}
	
	@action
	postBib(browserEvent)
	{
		this.saveBib(true);
	}
}
